import { CroutonIds } from "@swiggy-private/cart-types";

export interface IGenericCrouton {
    setCroutonVisibility: (croutonVisibility: boolean) => void;
    canShowTimer: boolean;
    uploadId?: string;
}

export const SUPPORTED_CROUTON_TYPES: CroutonIds[] = [
    CroutonIds.TIMED_FREE_CASH_CROUTON,
    CroutonIds.DEAL_RUSH,
    CroutonIds.MAGIC_ITEMS,
    CroutonIds.HOTEL_IN_ROOM_DELIVERY,
];
